import React, { useState, useRef } from 'react';
import { Play, X } from 'lucide-react';

const VideoPreview = ({ highlight, className = "" }) => {
  const [showVideo, setShowVideo] = useState(false);
  const videoRef = useRef(null);

  const handleVideoClick = () => {
    if (highlight.media_type === 'video' && highlight.media_url) {
      setShowVideo(true);
    }
  };

  const handleCloseVideo = () => {
    setShowVideo(false);
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  return (
    <>
      <div 
        className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden cursor-pointer hover:shadow-md transition-shadow ${className}`}
        onClick={handleVideoClick}
      >
        <div className="relative h-32 bg-gray-100">
          {highlight.media_type === 'video' ? (
            <>
              <video
                src={highlight.media_url}
                className="w-full h-full object-cover"
                muted
                preload="metadata"
              />
              <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
                <div className="w-12 h-12 bg-white bg-opacity-90 rounded-full flex items-center justify-center">
                  <Play className="text-gray-800 ml-1" size={20} />
                </div>
              </div>
            </>
          ) : (
            <img
              src={highlight.media_url}
              alt={highlight.title}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          )}
        </div>
        <div className="p-4">
          <h3 className="font-semibold text-gray-900 mb-1">{highlight.title}</h3>
          <p className="text-sm text-gray-500">
            {highlight.created_at ? new Date(highlight.created_at).toLocaleDateString('en-US', { 
              month: 'short', 
              day: 'numeric', 
              year: 'numeric' 
            }) : ''}
          </p>
        </div>
      </div>

      {/* Video Modal */}
      {showVideo && highlight.media_type === 'video' && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50">
          <div className="relative max-w-4xl w-full mx-4">
            <button
              onClick={handleCloseVideo}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <X size={24} />
            </button>
            <video
              ref={videoRef}
              src={highlight.media_url}
              className="w-full h-auto max-h-[80vh] rounded-lg"
              controls
              autoPlay
            />
          </div>
        </div>
      )}
    </>
  );
};

export default VideoPreview; 